// extracted by mini-css-extract-plugin
export default {"cols":"style_cols__GhjtH","logsText":"style_logsText__jyZTA","historyLink":"style_historyLink__rCR3H"};